<template>
    <Overlay :key="dialogKey" :show="isShow" :z-index="zIndex" class-name="wf-overlay">
        <div class="wf-dialog-wrapper">
            <div class="wf-dialog" :style="`width: ${width}`">
                <div class="wf-dialog-title">{{title}}</div>
                <div class="wf-dialog-content">
                    <slot></slot>
                </div>
                <div class="wf-dialog-bottom">
                    <div class="wf-dialog-bottom-cancel">
                        <Button plain @click="handleCancel">{{cancelText}}</Button>
                    </div>

                    <div class="wf-dialog-bottom-confirm">
                        <Button @click="handleConfirm">{{confirmText}}</Button>
                    </div>
                </div>
            </div>
        </div>
    </Overlay>
</template>

<script>
import Button from '../button/button.vue'
import Overlay from 'vant/lib/overlay';
export default {
    components: {
        Overlay,
        Button
    },
    data() {
        return {
            dialogKey: Math.random()
        }
    },
    model: {
        prop: 'isShow',
        event: 'change'
    },
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        zIndex: {
            type: Number,
            default: 99
        },
        width: {
            type: String,
            default: '531px'
        },
        title: {
            type: String,
            default: ''
        },
        confirmText: {
            type: String,
            default: "确定"
        },
        cancelText: {
            type: String,
            default: "取消"
        }
    },
    methods: {

        // 处理点击取消事件
        handleCancel() {
            this.$emit('cancel')
        },

        // 处理点击确定事件
        handleConfirm() {
            this.$emit('confirm')
        }
    },
    watch: {
        isShow() {
            this.dialogKey = Math.random()
        }
    }
}
</script>

<style lang="scss" scoped>
.wf-overlay {
    overflow-y: auto;
}
.wf-dialog-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100%;
    margin: 32px 0;
    .wf-dialog {
        padding: 30px 0;
        .wf-dialog-title {
            text-align: center;
            font-size: 16px;
            line-height: 16px;
            color: #333;
        }

        .wf-dialog-content {
            margin-top: 20px;
        }

        .wf-dialog-bottom {
            display: flex;
            flex-direction: row;
            justify-content: center;
            margin-top: 30px;
        }

        .wf-dialog-bottom-cancel,
        .wf-dialog-bottom-confirm {
            width: 80px;
        }

        .wf-dialog-bottom-cancel {
            margin-right: 60px;
        }
        background-color: #fff;
    }
	@media screen and (max-width: 768px) {
		.wf-dialog {
			width: 6.5rem !important;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/dialog.vue